import type { ChatContext, ChatMessage, ChatSession } from '@unity-learning/shared';
import { closeChatSession, getOrCreateChatSession, sendChatMessage } from './api';

/**
 * Façade historique du chatbot pédagogique. Les appels passent par le client API
 * unique (`services/api/chat.ts`) ; cette classe ne fait que garder la signature
 * attendue par `PedagogicalChatbot.tsx`.
 */
export class ChatService {
  /** Créer ou récupérer la session de chat d'un exercice (délai de 10 s). */
  static getOrCreateSession(exerciseId: string): Promise<ChatSession> {
    return getOrCreateChatSession(exerciseId);
  }

  /** Envoyer un message et recevoir la réponse du coach (1 appel Gemini). */
  static sendMessage(
    sessionId: string,
    exerciseId: string,
    message: string,
    context: ChatContext
  ): Promise<{ userMessage: ChatMessage; assistantMessage: ChatMessage; suggestions: string[] }> {
    return sendChatMessage({ sessionId, exerciseId, message, context });
  }

  static closeSession(sessionId: string): Promise<void> {
    return closeChatSession(sessionId);
  }
}
